import { render, staticRenderFns } from "./VPolygonMap.vue?vue&type=template&id=0ce6bb38"
import script from "./VPolygonMap.vue?vue&type=script&lang=ts"
export * from "./VPolygonMap.vue?vue&type=script&lang=ts"
import style0 from "./VPolygonMap.vue?vue&type=style&index=0&id=0ce6bb38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports